import { Fragment } from "react";
import styled from "styled-components";
import { Typography, Checkbox, Grid } from "@mui/material";
import { ToggleOnOutlined, ToggleOffOutlined } from "@mui/icons-material";

import Input from "./audience fields/Input";
import Range from "./audience fields/Range";
import DropDown from "./audience fields/Dropdown";
import DatePicker from "./audience fields/DatePicker";
import AudienceName from "./audience fields/AudienceName";
import { colors } from "../../css components/Style";

const Heading = styled(Typography)`
  font-size: 15px;
  font-weight: 500;
  line-height: 27px;
  align-self: center;
`;

export default function FormOne({
  setFields,
  state,
  categories,
  dispatch,
  fields,
  editState,
  formikProps,
  setButtonDisable,
}) {
  return (
    <Fragment>
      <Grid container spacing={4}>
        <Grid size={12} />

        <AudienceName
          setFields={setFields}
          state={state}
          dispatch={dispatch}
          editState={editState}
          formikProps={formikProps}
        />

        {categories?.map(
          (category) =>
            fields.find((f) => f.category?.category_title === category) && (
              <Fragment>
                <Grid size={12} style={{ margin: "20px 0" }}>
                  <Typography variant="h4" color={colors.sprintexBlue}>
                    {category !== "Others" && category}
                  </Typography>
                </Grid>

                {fields.map(
                  (field) =>
                    field.category?.category_title === category && (
                      <Fragment>
                        {field.control_id === 3 && (
                          <Input
                            setButtonDisable={setButtonDisable}
                            state={state}
                            dispatch={dispatch}
                            editState={editState}
                            field={field}
                            formikProps={formikProps}
                          />
                        )}

                        {field.control_id === 1 && (
                          <Range
                            setButtonDisable={setButtonDisable}
                            state={state}
                            dispatch={dispatch}
                            editState={editState}
                            field={field}
                            formikProps={formikProps}
                          />
                        )}

                        <DropDown
                          state={state}
                          dispatch={dispatch}
                          editState={editState}
                          field={field}
                          formikProps={formikProps}
                        />

                        {field.control_id === 4 && (
                          <DatePicker
                            state={state}
                            dispatch={dispatch}
                            editState={editState}
                            field={field}
                            formikProps={formikProps}
                          />
                        )}
                      </Fragment>
                    )
                )}
              </Fragment>
            )
        )}
      </Grid>
    </Fragment>
  );
}

export function Mandatory({ state, field, dispatch, editState }) {
  function handleCheckChange(value, name, key) {
    dispatch({
      type: "CALCULATE_PERCENTAGE",
      payload: { value, name, key },
    });
  }

  return (
    <div style={{ display: "flex", justifyContent: "end" }}>
      <Heading
        style={{
          color: state?.[field.name]?.mandatory ? "red" : "gray",
        }}
      >
        Mandatory
      </Heading>

      <Checkbox
        style={{ padding: "3px 9px" }}
        disabled={
          field.control_id === 1
            ? !state?.[field.name]?.value?.min ||
              !state?.[field.name]?.value?.max ||
              !editState
            : !editState ||
              !state?.[field.name]?.value ||
              state?.[field.name]?.value?.length === 0
        }
        name={`${field.name}.mandatory`}
        onChange={(e) => {
          handleCheckChange(e.target.checked, field.name, "mandatory");
        }}
        checked={state?.[field.name]?.mandatory}
        icon={<ToggleOffOutlined fontSize="large" />}
        checkedIcon={
          <ToggleOnOutlined
            fontSize="large"
            style={{
              color: state?.[field.name]?.mandatory ? "red" : "#cbcbcb",
            }}
          />
        }
      />
    </div>
  );
}
